import React from 'react';
import shallowEqual from 'shallowequal';

import {
  priceLabelStylingType,
  priceLabel,
} from '@prisjakt/ui-price-label/src/types';
import ShippingLabel from '../../../shipping-label';

import { PricePrice } from '../../../../types';
import { Align } from '../../types';
import {
  SortOption,
  SortOptionEnum,
} from '../../../../areas/product/components/sort-options/types';

import * as S from './styles';

type OwnProps = {
  price: PricePrice;
  storeIsFeatured?: boolean | null;
  campaignStyling?: { background: string; text: string; name: string } | null;
  align?: Align;
  currentSort: SortOption;
};

const PriceColumn = React.memo(
  ({
    price,
    storeIsFeatured,
    campaignStyling,
    align,
    currentSort,
  }: OwnProps) => {
    const getPriceLabelStyling = () => {
      if (!storeIsFeatured) return priceLabel.LIGHTEN;
      if (campaignStyling) return priceLabel.CAMPAIGN;
      return priceLabel.PRIMARY;
    };

    const shippingLabel = () => (
      <S.ShippingLabelWrapper>
        <S.Hidden>&nbsp;(</S.Hidden>
        {price.exclShipping && (
          <ShippingLabel
            toneDown
            exclShipping={price.exclShipping}
            inclShipping={price.inclShipping}
            currentSort={currentSort}
            compact
          />
        )}

        <S.Hidden>)</S.Hidden>
      </S.ShippingLabelWrapper>
    );

    const renderPriceLabel = () => {
      const mainPrice =
        currentSort === SortOptionEnum.PRICE_INCLUDES_SHIPPING &&
        price.inclShipping
          ? price.inclShipping
          : price.exclShipping;

      return (
        mainPrice && (
          <S.PriceLabel
            value={mainPrice}
            styling={getPriceLabelStyling() as priceLabelStylingType}
            campaignStyling={campaignStyling}
          />
        )
      );
    };

    const renderShippingLabel = () => {
      if (
        (currentSort !== SortOptionEnum.PRICE_INCLUDES_SHIPPING &&
          price.inclShipping) ||
        (currentSort === SortOptionEnum.PRICE_INCLUDES_SHIPPING &&
          !price.inclShipping)
      ) {
        return shippingLabel();
      }

      if (
        price.inclShipping ||
        (currentSort === SortOptionEnum.PRICE_INCLUDES_SHIPPING &&
          !price.inclShipping)
      ) {
        return shippingLabel();
      }

      return null;
    };

    return (
      <S.PriceColumn align={align}>
        {renderPriceLabel()}
        {renderShippingLabel()}
      </S.PriceColumn>
    );
  },
  (prevProps, nextProps) => {
    const { price: prevPrice, ...prevRest } = prevProps;
    const { price: nextPrice, ...nextRest } = nextProps;
    return (
      shallowEqual(prevPrice, nextPrice) && shallowEqual(prevRest, nextRest)
    );
  }
);

export default PriceColumn;
